import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import MallIntegrationIcon from '@material-ui/icons/CompareArrows';

import { CreateButton } from 'react-admin';

const MallIntegrationEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <MallIntegrationIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No mall integration available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default MallIntegrationEmpty;
